import { ExternalLinkIcon } from "@radix-ui/react-icons";
import Link from "next/link";
import { Button } from "../ui/button";
import {
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
} from "../ui/credenza";
import { useTranslations } from "next-intl";
import Image from "next/image";

export default function DeniedNotificationPermissionCredenzaContent({
  setOpen,
}: any) {
  const t = useTranslations("Notifications");
  return (
    <CredenzaContent className="md:max-w-2xl">
      <CredenzaHeader>
        <CredenzaTitle>
          {t("denied-title")}
        </CredenzaTitle>
        <CredenzaDescription className="py-5">
      <Image src={'/illustrations/glass/3d-glassy-composition-with-smartphone-mockup-and-sphere.png'} height={200} width={200} alt='notifications' className="mx-auto"/>

          {t('denied-description')}
        </CredenzaDescription>
      </CredenzaHeader>

      <CredenzaFooter className="space-y-2 sm:flex-col sm:justify-stretch sm:space-x-0">
        <Button
          className="w-full gap-x-2"
          asChild
          onClick={() => setOpen(false)}
        >
          <Link
            href="https://knowledge.workspace.google.com/kb/how-to-enable-browser-notifications-000007831"
            target="_blank"
          >
            {t("denied-button")} <ExternalLinkIcon />
          </Link>
        </Button>
      </CredenzaFooter>
    </CredenzaContent>
  );
}

export async function getServerSideProps(context: any) {
  return {
    props: {
      messages: (await import(`@/public/i18n/${context.locale}.json`)).default,
    },
  };
}
